import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { formatURL } from '../../../utils';
import { closeModalQuotationDateWarning } from '../../../actions/searchActions';

export class ModalQuotationDateWarning extends Component {
  constructor(props) {
    super(props);

    this.goToSearchPage = this.goToSearchPage.bind(this);
  }

  goToSearchPage() {
    this.props.closeModalQuotationDateWarning();
    const location = {
      pathname: formatURL(
        this.props.match,
        `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
        null
      ),
    };
    this.props.history.replace(location);
  }

  render() {
    if (!this.props.isModalQuotationDateWarningActive) return <div />;

    return (
      <div className="comp_modalpagamento quotationDateWarning-modal">
        <div className="modalcontents modalfranquia">
          <div className="modalHeader">
            <div>
              <h5>
                Informação importante sobre sua compra
              </h5>
            </div>
            <div onClick={this.props.closeModalQuotationDateWarning} className="close-btn">
              {' '}
              &times;{' '}
            </div>
          </div>
          
          <div className="contents">
             <img
                className="calendar-icon"
                src="/assets/images/calendar-new.svg"
                alt="Você está pesquisando um seguro viagem para hoje"
              />
            <div className="modalmiddle">
              <h5>
                Você está pesquisando um seguro viagem para hoje
              </h5>

              <p className="text-middle">
                Sua apólice será válida somente se for emitida antes do início da sua viagem. 
              </p>
              <p className="text-middle">
                Em caso de dúvida, {' '}
                <a rel="noopener noreferrer" target="_blank" href="https://segurospromo.com.br/atendimento">
                  fale com o nosso atendimento
                </a>
                .
              </p>

              <div className="wrapper-list-contact">
                <ul className="list-contact">
                  <li>
                    <div className="contact-wrapper">
                      <img
                        className="contact-icon"
                        src="/assets/images/icons/wppGreen.svg"
                        alt="Você está pesquisando um seguro viagem para hoje"
                      />
                      <strong>WhatsApp</strong>
                    </div>
                    <div>
                      <a
                        href="https://api.whatsapp.com/send?phone=553139727083&text=Seguros%20Promo"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (31) 3972-7083
                      </a>
                    </div>
                  </li>
                </ul>
                <ul className="list-contact">
                  <li>
                    <div className="contact-wrapper">
                      <img
                        className="contact-icon"
                        src="/assets/images/icons/phone2green.svg"
                        alt="Você está pesquisando um seguro viagem para hoje"
                      />
                      <strong>Atendimento</strong>
                    </div>
                    <div>
                      <a href="tel:(31) 4003-8442" target="_blank" rel="noopener noreferrer">
                        (31) 4003-8442
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="choosecontainer">
              <div className="optionone">
                <button className="button" onClick={this.props.closeModalQuotationDateWarning}>
                  <span>Continuar Pesquisa</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isModalQuotationDateWarningActive: state.comparison.isModalQuotationDateWarningActive,
  }),
  {
    closeModalQuotationDateWarning,
  }
)(withRouter(ModalQuotationDateWarning));



// WEBPACK FOOTER //
// ./src/components/common/modal_quotation_date_warning/ModalQuotationDateWarning.jsx